import { render, staticRenderFns } from "./Revoke.vue?vue&type=template&id=b03230e2&scoped=true&"
import script from "./Revoke.vue?vue&type=script&lang=js&"
export * from "./Revoke.vue?vue&type=script&lang=js&"
import style0 from "./Revoke.vue?vue&type=style&index=0&id=b03230e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03230e2",
  null
  
)

export default component.exports